import React, { Component } from 'react';

export default class ContestsCardItem extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {

        }

        //methods
        this.selectContest = this.selectContest.bind(this);
        this.deleteContest = this.deleteContest.bind(this);
        this.handleArchive = this.handleArchive.bind(this);
        this.goInfo = this.goInfo.bind(this);
        this.goEdit = this.goEdit.bind(this);
        this.goResults = this.goResults.bind(this);

    }

    componentDidMount() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }

    selectContest() {
        this.props.handleSelectContest(this.props.identity);
    }

    deleteContest() {
        this.props.handleDelete(this.props.identity);
    }

    handleArchive() {
        if (this.props.category != "active") {
            this.props.handleArchive(this.props.identity, this.props.category === "complete");
        }
    }

    goInfo() {
        // this.props.handleModeChange("info");
        this.props.startInfoContest();
    }

    goEdit() {
        this.props.startEditContest();
    }

    goResults() {
        this.props.startResultsContest();
    }

    render() {

        let identity = this.props.identity;

        let outerClass = 'settings-card-item-outer';
        if (this.props.isActive) {
            outerClass += ' settings-card-item-outer--active';
        }
        let color = '#F8F9FB'; 
        
        return (
            <div className={outerClass}>
                <div className="settings-card-item-icon-container" onClick={this.selectContest}>
                    <div className="settings-card-item-icon">
                        <svg className="filler-svg-dark" style={{ fill: color }} version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 297 297">
                            <g>
                                <g>
                                    <path d="M174.691,194.214c0-2.718-2.152-4.382-4.782-3.698c0,0-12.318,3.201-21.409,3.201s-21.409-3.201-21.409-3.201 c-2.63-0.684-4.782,0.98-4.782,3.698v14.329c0,2.718,2.224,4.941,4.941,4.941h42.5c2.718,0,4.941-2.224,4.941-4.941V194.214z" />
                                </g>
                                <g>
                                    <path d="M223.615,9.884c0-5.458-4.426-9.884-9.884-9.884H83.269c-5.458,0-9.884,4.426-9.884,9.884v81.539 c0,25.522,7.591,48.754,21.374,65.415c13.874,16.771,32.96,26.008,53.741,26.008c20.781,0,39.867-9.236,53.741-26.008 c13.783-16.661,21.374-39.893,21.374-65.415V9.884z" />
                                </g>
                                <g>
                                    <path d="M63.981,111.227c-13.525-5.033-19.753-16.706-19.753-36.111V30.969h18.285V11.202H34.346 c-5.459,0-9.884,4.425-9.884,9.884v54.029c0,32.961,15.788,53.039,44.818,57.729C66.895,125.985,65.109,118.749,63.981,111.227z" />
                                </g>
                                <g>
                                    <path d="M83.269,228.31c-5.458,0-9.884,4.425-9.884,9.884v48.923c0,5.458,4.426,9.884,9.884,9.884h130.463 c5.458,0,9.884-4.426,9.884-9.884v-48.923c0-5.459-4.426-9.884-9.884-9.884H83.269z" />
                                </g>
                                <g>
                                    <path d="M262.654,11.202h-28.168v19.767h18.285v44.146c0,19.405-6.228,31.078-19.753,36.111 c-1.128,7.522-2.913,14.759-5.299,21.618c29.03-4.69,44.818-24.768,44.818-57.729V21.086 C272.538,15.627,268.113,11.202,262.654,11.202z" />
                                </g>
                            </g>
                        </svg>
                    </div>
                </div>
                <div className="settings-card-name-container" onClick={this.selectContest}>
                    <div className="settings-card-name"><span className={"material-icons settings-card-name-icon"}>{identity.participantType === "loc" ? "store_mall_directory" : "person"}</span> {identity.name}</div>
                    <div className="settings-card-secondary">{identity.description}</div>
                </div>
                <div className="settings-card-bottom-container">
                    <div className="material-icons settings-card-bottom-item" onClick={this.goInfo}>info_outline</div>
                    {
                        identity.isArchived ? null :
                            <div className="material-icons settings-card-bottom-item" onClick={this.goResults}>star_border</div>
                    }
                    {
                        this.props.category === "active" ? (<div className="material-icons settings-card-bottom-item" onClick={this.goEdit}>edit</div>) : null
                    }
                    {
                        this.props.category === "active" ? null : (identity.isArchived ? (<div className="material-icons settings-card-bottom-item" onClick={this.handleArchive}>unarchive</div>) :
                        (<div className="material-icons settings-card-bottom-item" onClick={this.handleArchive}>archive</div>))
                    }
                    <div className="material-icons settings-card-bottom-item" onClick={this.deleteContest}>delete</div>
                </div>
            </div>
        );
    }
}